import moment from "moment";

export const inputValidationChecks = (value, validation, setError) => {
	let fieldValidationErrors = "";
	let valid = false;

	switch (validation) {
		case "vin":
			valid = value.match(/^.{4}$|^.{17}$/);
			fieldValidationErrors = valid ? "" : "Please use a proper Vin number.";
			break;
		case "model":
			valid = value !== "";
			fieldValidationErrors = valid ? "" : "Please complete the Model.";
			break;
		case "first_name":
			valid = value !== "";
			fieldValidationErrors = valid
				? ""
				: "Please complete with your First Name.";
			break;
		case "last_name":
			valid = value !== "";
			fieldValidationErrors = valid
				? ""
				: "Please complete with your Last Name.";
			break;
		case "email":
			valid = value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);
			fieldValidationErrors = valid
				? ""
				: "Please complete with a valid Email.";
			break;
		case "street":
			valid = value !== "";
			fieldValidationErrors = valid ? "" : "Please complete with your Street.";
			break;
		case "city":
			valid = value !== "";
			fieldValidationErrors = valid ? "" : "Please complete with your City.";
			break;
		case "zipCode":
			valid = value !== "";
			fieldValidationErrors = valid
				? ""
				: "Please complete with your Zip Code.";
			break;
		case "lien":
			valid = value !== "";
			fieldValidationErrors = valid
				? ""
				: "Please complete with your Lien Holder Name.";
			break;
		case "company":
			valid = value !== "";
			fieldValidationErrors = valid
				? ""
				: "Please complete with the Company Name.";
			break;
		case "birthDate":
			valid = value !== "";
			fieldValidationErrors = valid ? "" : "Please select a Date of Birth.";
			if (valid) {
				var years = moment().diff(value, "years");
				valid = years >= 25;
				fieldValidationErrors = valid ? "" : "You must be 25 years or older.";
			}
			break;
		default:
			break;
	}
	setError(fieldValidationErrors);

	return fieldValidationErrors !== "";
};

export const selectValidationChecks = (value, validation, setError, productExceptionMessages) => {
	let fieldValidationErrors = "";
	let valid = false;
	let customExceptionMessages = productExceptionMessages ? JSON.parse(productExceptionMessages) : {}

	switch (validation) {
		case "year":
			valid = value !== "";
			fieldValidationErrors = valid ? "" : "Please select an option.";
			break;
		case "make":
			valid = value !== "";
			fieldValidationErrors = valid ? "" : "Please select an option.";
			if (valid) {
				//valid = value !== "Ferrari";
				valid = !customExceptionMessages.hasOwnProperty(value);
				fieldValidationErrors = valid
					? ""
					: customExceptionMessages[value];
			}
			break;
		case "value":
			valid = value !== "";
			fieldValidationErrors = valid ? "" : "Please select an option.";
			break;
		case "state":
			valid = value !== "";
			fieldValidationErrors = valid ? "" : "Please select an option.";
			break;
		case "country":
			valid = value !== "";
			fieldValidationErrors = valid ? "" : "Please select an option.";
			break;
		case "municipality":
			valid = value !== "";
			fieldValidationErrors = valid ? "" : "Please select an option.";
			break;
		case "lien":
			valid = value !== "";
			fieldValidationErrors = valid ? "" : "Please select an option.";
			break;
		case "carOwnership":
			valid = value !== "";
			fieldValidationErrors = valid ? "" : "Please select an option.";
			break;
		case "relation":
			valid = value !== "";
			fieldValidationErrors = valid ? "" : "Please select an option.";
			break;

		default:
			break;
	}
	setError(fieldValidationErrors);

	return fieldValidationErrors !== "";
};
